import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "antd";
import { func, string } from "prop-types";

const RemoveFormItem = ({ parentComponent, remove, uniqueId }) => {
  let dataTestId = `${parentComponent}-remove-form-item`;

  if (uniqueId) dataTestId += `-${uniqueId}`;

  return (
    <Form.Item>
      <FontAwesomeIcon
        icon={faCircleMinus}
        data-test-id={dataTestId}
        onClick={() => {
          remove();
        }}
      />
    </Form.Item>
  );
};

RemoveFormItem.propTypes = {
  parentComponent: string.isRequired,
  remove: func.isRequired,
  uniqueId: string,
};

export default RemoveFormItem;
